import Component from './twitter_timeline_widget.vue'
export default Component
